import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";
import CarditCriticalElementsReport from "../../components/CarditCriticalElementsReport";
import {
  getPercentageColumns,
  getNumberColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from "../redux/selectors/CarditCriticalElementsCarrierSelectors";
import CarditCriticalElementsCarrierReportMode from "./CarditCriticalElementsCarrierReportMode";

const MODE_TABS = [
  { value: CarditCriticalElementsCarrierReportMode.percentage, label: "%" },
  { value: CarditCriticalElementsCarrierReportMode.number, label: "#" },
];

export class CarditCriticalElementsCarrierContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: CarditCriticalElementsCarrierReportMode.percentage,
    };
  }

  changeMode = (reportMode) => this.setState({ reportMode });

  renderPercentage() {
    return (
      <CarditCriticalElementsReport
        reportId={ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id}
        prepareData={(d) =>
          d.filter(
            (row) => row.carrier && row.carrier.toLowerCase() !== "total"
          )
        }
        columns={this.props.percentageColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarditCriticalElementsCarrierReportMode.percentage}
      />
    );
  }

  renderNumber() {
    return (
      <CarditCriticalElementsReport
        reportId={ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id}
        prepareData={(d) =>
          d.filter(
            (row) => row.carrier && row.carrier.toLowerCase() !== "total"
          )
        }
        columns={this.props.numberColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarditCriticalElementsCarrierReportMode.number}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case CarditCriticalElementsCarrierReportMode.percentage:
        return this.renderPercentage();
      case CarditCriticalElementsCarrierReportMode.number:
        return this.renderNumber();
      default:
        return (
          <div id="report-mode-error">
            Report mode &quot;{this.state.reportMode}&quot; is not implemented
          </div>
        );
    }
  }
}
function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    percentageColumns: getPercentageColumns(state),
    numberColumns: getNumberColumns(state),
  };
}

CarditCriticalElementsCarrierContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  percentageColumns: PropTypes.arrayOf(PropTypes.object),
  numberColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CarditCriticalElementsCarrierContainer);
